import React from "react";
import { Box, Flex, Stack } from "@chakra-ui/react";

import Brand from "@/src/components/sidebar/components/Brand";
import Links from "@/src/components/sidebar/components/Links";
import { RoutesType } from "@/src/routes";
import { Button } from "@/src/components/ui/button";
import { useAuthStore } from "@/src/store/auth";

function SidebarContent(props: { routes: RoutesType[] }) {
  const { routes } = props;
  const { logout } = useAuthStore();

  return (
    <Flex direction="column" height="100%" pt="25px" borderRadius="30px">
      <Brand />
      <Stack direction="column" mt="8px" mb="auto">
        <Box ps="20px" pe={{ lg: "16px", "2xl": "16px" }}>
          <Links routes={routes} />
        </Box>
      </Stack>
      <Flex p={4}>
        <div className="flex justify-end  flex-1">
          <Button
            variant="link"
            onClick={() => {
              logout();
            }}
          >
            Logout
          </Button>
        </div>
      </Flex>
    </Flex>
  );
}

export default SidebarContent;
